/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.urls.rpc.ScreenshotRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import * as References from './ScreenshotRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.urls.rpc.ScreenshotRpc#getScreenshot
 */
export const GET_SCREENSHOT_QUERY_FIELD_NAME = 'com_hubspot_marketplace_urls_rpc_ScreenshotRpc_getScreenshot';
export const GET_SCREENSHOT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SCREENSHOT_QUERY_FIELD_NAME,
  args: ['siteKey', 'path', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getScreenshotRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});